import Clap from "./assets/emoji_clap.svg";
import Laugh from "./assets/emoji_laugh.svg";
import DrumRoll from "./assets/drum-svgrepo-com.svg";
import Cheer from "./assets/megaphone-svgrepo-com.svg";

const APPLAUSE_SOUND = require("./assets/sounds/applause.mp3");
const CHEER_SOUND = require("./assets/sounds/cheer.mp3");
const DRUMROLL_SOUND = require("./assets/sounds/drumroll.mp3");
const LAUGH_SOUND = require("./assets/sounds/laugh.mp3");

export const audioReactions = {
  applause: Clap,
  cheer: Cheer,
  drumRoll: DrumRoll,
  laughter: Laugh,
};

export enum AudioReactionsTypes {
  applause = "applause",
  cheer = "cheer",
  drumRoll = "drumRoll",
  laughter = "laughter",
}

export const AudioReactionsPath = {
  applause: APPLAUSE_SOUND,
  drumRoll: DRUMROLL_SOUND,
  cheer: CHEER_SOUND,
  laughter: LAUGH_SOUND,
};

export const SOUND_INTERVAL = 300; // in ms
// Note: volume range is [0-1]
export const INITIAL_VOLUME = 0.2;
export const VOLUME_CHANGE_BY = 0.15;
export const INCREASE_VOLUME_UPTO = 1;

// All below values are in seconds
export const START_DECREASE_VOLUME_BEFORE = 2.5;
export const DECREASE_VOLUME_UPTO = 0.25;
